// extracted by mini-css-extract-plugin
export var content = "styles-module--content--67f28";
export var fadeIn = "styles-module--fadeIn--089d7";
export var githubIcon = "styles-module--githubIcon--3746a";
export var githubLink = "styles-module--githubLink--aec24";
export var navButton = "styles-module--navButton--97c60";
export var navButtonIcon = "styles-module--navButtonIcon--e5248";
export var navButtons = "styles-module--navButtons--4e2fb";
export var next = "styles-module--next--aa49e";
export var prev = "styles-module--prev--99ec2";
export var tutorialsWrapper = "styles-module--tutorialsWrapper--1bc28";